import React, { useCallback, useEffect, useState } from 'react';
import { Card, FadeIn, Badge } from '../components/ui';
import { rupee } from '../theme';
import api from '../api/client';
import { demoEarnings } from '../api/demo';

export default function StaffEarnings() {
  const [data, setData] = useState(demoEarnings);
  const [refreshing, setRefreshing] = useState(false);

  const load = useCallback(() => api.get('/bookings/earnings')
    .then((d) => { if (d) setData({ ...demoEarnings, ...d }); })
    .catch(() => {})
    .finally(() => setRefreshing(false)), []);

  useEffect(() => { load(); }, [load]);
  const onRefresh = () => { setRefreshing(true); load(); };

  const history = data.salaryHistory?.length ? data.salaryHistory : demoEarnings.salaryHistory;

  return (
    <div className="screen">
      <div className="page-head row-between">
        <div>
          <h1>Earnings</h1>
          <p>Salary credited by admin for your jobs</p>
        </div>
        <button className="chip" onClick={onRefresh} disabled={refreshing}>
          {refreshing ? 'Refreshing…' : '↻ Refresh'}
        </button>
      </div>

      <div style={{ padding: 16 }}>
        <FadeIn>
          <div style={{
            background: 'var(--primary)', borderRadius: 'var(--r-xl)', padding: 22,
            color: '#fff', boxShadow: 'var(--shadow-brand)',
          }}>
            <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13.5 }}>Total settled by admin</div>
            <div style={{ fontSize: 36, fontWeight: 800, marginTop: 4 }}>
              {rupee(data.totalPaid || data.totalCredited)}
            </div>
            <div className="row" style={{ marginTop: 18 }}>
              {[
                [rupee(data.monthlyAgreed), 'Monthly (active)'],
                [data.activeJobs, 'Active jobs'],
                [data.completedJobs, 'Completed'],
              ].map(([v, l], i) => (
                <React.Fragment key={l}>
                  {i > 0 && <span style={{ width: 1, height: 32, background: 'rgba(255,255,255,0.25)' }} />}
                  <div style={{ flex: 1, textAlign: 'center' }}>
                    <div style={{ fontSize: 17, fontWeight: 800 }}>{v}</div>
                    <div style={{ fontSize: 11, marginTop: 2, color: 'rgba(255,255,255,0.8)' }}>{l}</div>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>
        </FadeIn>

        {data.payouts?.length > 0 && (
          <>
            <h2 style={{ fontSize: 16, fontWeight: 800, marginTop: 26, marginBottom: 12 }}>Settled payouts</h2>
            {data.payouts.map((p, i) => (
              <FadeIn key={p._id || i} delay={i * 50}>
                <Card className="row" style={{ gap: 14, marginBottom: 12 }}>
                  <span style={{
                    width: 42, height: 42, borderRadius: 'var(--r-md)', background: '#FCF1DA',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flex: 'none',
                  }}>🏦</span>
                  <div className="grow">
                    <div style={{ fontWeight: 700, fontSize: 14.5 }}>Payout · {p.month}</div>
                    {p.note ? <div className="muted" style={{ fontSize: 12, marginTop: 2 }}>{p.note}</div> : null}
                  </div>
                  <span style={{ fontWeight: 800, fontSize: 15, color: 'var(--success)' }}>+{rupee(p.amount)}</span>
                </Card>
              </FadeIn>
            ))}
          </>
        )}

        <h2 style={{ fontSize: 16, fontWeight: 800, marginTop: 26, marginBottom: 12 }}>Salary credited (per service)</h2>
        {history.map((h, i) => (
          <FadeIn key={i} delay={i * 60}>
            <Card className="row" style={{ gap: 14, marginBottom: 12 }}>
              <span style={{
                width: 42, height: 42, borderRadius: 'var(--r-md)', background: '#E5F5EE',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flex: 'none',
              }}>💵</span>
              <div className="grow">
                <div style={{ fontWeight: 700, fontSize: 14.5 }}>{h.title}</div>
                <div className="row" style={{ gap: 8, marginTop: 3 }}>
                  <Badge label={h.month} tone="neutral" />
                  <span className="faint" style={{ fontSize: 12 }}>{h.bookingCode}</span>
                </div>
              </div>
              <span style={{ fontWeight: 800, fontSize: 15, color: 'var(--success)' }}>+{rupee(h.amount)}</span>
            </Card>
          </FadeIn>
        ))}
      </div>
    </div>
  );
}
